module.exports = __webpack_public_path__ + "img/85.head_coverage.593eaa36.svg";